<template>
    <div>
        <div class="row">
            <div class="col-sm-10 offset-sm-1 col-md-8 offset-md-2">
                <div class="container black-bg p-4 mt-3 mt-md-5 mb-5">
                    <header>
                        <div class="row">
                            <div class="col-md-1">
                                <div class="text-center">
                                    <img src="../../assets/icons/ic_menu.svg" alt="menu">
                                </div>
                            </div>

                            <div class="offset-3 col-sm-4">
                                <div class="text-center">
                                    <img class="icon-md" src="../../assets/icons/ic_cloud.svg" alt="cloud">
                                    <p class="mt-2">HOMEPORT CLOUD @Dims_80</p>
                                </div>
                            </div>

                            <div class="col-sm-1 offset-3">
                                <div>
                                    <img src="../../assets/icons/ic_content_copy.svg" alt="back">
                                    <p class="mt-2">BACK</p>
                                </div>
                            </div>
                        </div>
                    </header>

                    <section class="row mt-5">

                        <div class="col-sm-12 col-md-5">
                            <div class="row ml-1">

                                <div class="col-sm-12">
                                    <div>
                                        <p>Notifications</p>
                                        <img v-if="!isPaid" class="icon-sm" src="../../assets/icons/ic_notify_red.svg"
                                             alt="notifications">

                                        <img v-if="isPaid" class="icon-sm" src="../../assets/icons/ic_notify_yellow.svg"
                                             alt="notifications">

                                        <span v-bind:class="{'text-warning': isPaid, 'text-danger': !isPaid}" class="ml-1 small">PAYMENT PENDING</span>
                                    </div>

                                    <div class="mt-3">
                                        <p>Available funds</p>
                                        <img class="icon-sm" src="../../assets/icons/ic_wallet.svg" alt="wallet">
                                        <span class="ml-1 small">{{balance}} ETH</span>
                                    </div>

                                    <div class="mt-3">
                                        <p>Executed transactions</p>
                                        <img class="icon-sm" src="../../assets/icons/ic_library_books.svg"
                                             alt="contracts">
                                        <span class="ml-1 small">{{walletTransactionsCount}}</span>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div v-if="!isPaid" class="col-sm-12 col-md-7 vl">
                            <div class="row">

                                <div class="col-sm-12">
                                    <p>STATION: MONTEVIDEO</p>
                                    <p>WORK VALUE: {{station1WorkValue}} ETH</p>
                                    <p>STATION ADDRESS: {{station1Address}}</p>
                                    <a class="text-warning" v-if="href1" :href="href1" target="_blank">Click here to see your transaction</a>
                                </div>

                                <div class="col-sm-12 mt-3">
                                    <p>STATION: PRAGUE</p>
                                    <p>WORK VALUE: {{station2WorkValue}} ETH</p>
                                    <p>STATION ADDRESS: {{station2Address}}</p>
                                    <a class="text-warning" v-if="href2" :href="href2" target="_blank">Click here to see your transaction</a>
                                </div>

                                <div class="col-sm-12 mt-3">
                                    <p>STATION: PALERMO</p>
                                    <p>WORK VALUE: {{station3WorkValue}} ETH</p>
                                    <p>STATION ADDRESS: {{station3Address}}</p>
                                    <a class="text-warning" v-if="href3" :href="href3" target="_blank">Click here to see your transaction</a>
                                </div>

                                <div class="col-sm-12 mt-3">
                                    <button v-on:click="pay" class="btn btn-warning">PAYMENT</button>
                                </div>

                            </div>
                        </div>

                        <div class="mt-4 mb-5" v-if="isPaid">
                            <Spinner title="PROCESSING PAYMENT... PLEASE WAIT"/>
                        </div>

                    </section>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Spinner from '../shared/Spinner'
    import HomeportMarketplace from '../../assets/HomeportMarketplace'

    export default {
        name: 'Payment',
        data: function () {
            return {
                isPaid: false,
                balance: 0,
                provider: null,
                wallet: null,
                walletTransactionsCount: 0,
                marketplaceContract: null,
                href1: '',
                href2: '',
                href3: '',
                station1Address: '0x182c77541fd49e3345f84966987591138376be7f',
                station1WorkValue: '2',
                station2Address: '0x20cd03fc7d8d9482e9beb70abf5d1ef05ca30e40',
                station2WorkValue: '3',
                station3Address: '0x44da3a90d875498b2302547b77606c0a7827636c',
                station3WorkValue: '2',
                network: 'ropsten',
                infuraApiKey: 'debbc3ce2f19409eb26622617bbb2182',
                gasLimit: 5000000,
                // stored here only for demo purposes, never hard code in application
                privateKey: '0x64945E08E996637048396A73866E93C0D864498A0BB09B5A136EEA48E3B8F16C',
                marketplaceAddress: '0x236aA849da3462c8d7cC68C76F6007EcB70C4892',
                ropstenUrl: 'https://ropsten.etherscan.io/tx/',
                password: 'hpnetwork'
            }
        },
        async mounted() {
            let inputPassword
            while(this.password != inputPassword) {
                inputPassword = prompt('Please enter your password:')
            }
            this.provider = new ethers.providers.InfuraProvider(this.network, this.infuraApiKey)
            this.wallet = new ethers.Wallet(this.privateKey, this.provider)
            this.marketplaceContract = new ethers.Contract(this.marketplaceAddress, HomeportMarketplace.abi, this.provider)
            
            this.marketplaceContract = this.marketplaceContract.connect(this.wallet)
            
            this.balance = await this.getBalance()
            this.walletTransactionsCount = await this.getTransactionCount()
        },
        components: {
            Spinner
        },
        methods: {
            createPayFunctionData(address) {
                return this.marketplaceContract.interface.functions.pay.encode([address])
            },
            createTransaction(data, value, nonce) {
                return {
                    data: data,
                    to: this.marketplaceContract.address,
                    value: ethers.utils.parseEther(value),
                    gasLimit: this.gasLimit,
                    nonce: nonce
                }
            },
            formatEther(balanceInWei) {
                return Number(ethers.utils.formatEther(balanceInWei).toString()).toFixed(2)
            },
            async getBalance() {
                let balanceInWei = await this.wallet.getBalance()
                return this.formatEther(balanceInWei)
            },
            getEtherscanUrl(txHash) {
                return this.ropstenUrl + txHash
            },
            getTransactionCount() {
                return this.wallet.getTransactionCount()
            },
            async pay() {
                let that = this

                that.isPaid = true

                let baseNonce = this.provider.getTransactionCount(this.wallet.getAddress())
                let nonceOffset = 0

                async function getNonce() {
                    return baseNonce.then((nonce) => {
                        return (nonce + (nonceOffset++))
                    })
                }

                let data = this.createPayFunctionData(this.station1Address)
                let data2 = this.createPayFunctionData(this.station2Address)
                let data3 = this.createPayFunctionData(this.station3Address)

                const transaction1 = this.createTransaction(data, this.station1WorkValue, await getNonce())
                const transaction2 = this.createTransaction(data2, this.station2WorkValue, await getNonce())
                const transaction3 = this.createTransaction(data3, this.station3WorkValue, await getNonce())

                try {
                    let tx1 = await this.sendTransaction(transaction1)
                    let tx2 = await this.sendTransaction(transaction2)
                    let tx3 = await this.sendTransaction(transaction3)

                    this.href1 = this.getEtherscanUrl(tx1.hash)
                    this.href2 = this.getEtherscanUrl(tx2.hash)
                    this.href3 = this.getEtherscanUrl(tx3.hash)
                    this.isPaid = false

                    this.waitForTransaction(tx1.hash)
                    this.waitForTransaction(tx2.hash)
                    this.waitForTransaction(tx3.hash)
                }
                catch(err) {
                    this.isPaid = false
                }
            },
            sendTransaction(transaction) {
                return this.wallet.sendTransaction(transaction)
            },
            waitForTransaction(txHash) {
                this.provider.once(txHash, async (receipt) => {
                    this.balance = await this.getBalance()
                    this.walletTransactionsCount = await this.getTransactionCount()
                })
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    img {
        width: 25px;
    }

    p {
        font-size: 0.7rem;
        margin-bottom: 0;
    }
</style>
